import React from 'react';
import { Button } from './ui/Button';
import { Divider } from './ui/Divider';
export function PricingSection() {
  return <section id="pricing" className="bg-cream py-24 px-6" data-id="element-39">
      <div className="max-w-3xl mx-auto text-center" data-id="element-40">
        <h2 className="text-4xl md:text-5xl mb-6" data-id="element-41">The Price</h2>
        <Divider className="mb-8" data-id="element-42" />

        <div className="bg-white p-10 md:p-16 rounded-[2.5rem] shadow-xl border border-sage/10 relative overflow-hidden" data-id="element-43">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-sage via-olive-light to-sage" data-id="element-44"></div>

          <p className="text-lg text-warm-dark/60 mb-4 uppercase tracking-widest font-bold" data-id="element-45">
            You won't pay the standard price
          </p>

          <div className="flex items-center justify-center gap-6 mb-8" data-id="element-46">
            <span className="text-4xl md:text-5xl text-warm-dark/30 line-through font-heading decoration-sage/50" data-id="element-47">
              $57.00
            </span>
            <span className="text-6xl md:text-7xl font-heading text-olive-gold font-bold" data-id="element-48">
              $6.36
            </span>
          </div>

          <p className="text-xl text-olive-light font-heading italic mb-10" data-id="element-49">
            You get the full protocol today.
          </p>

          <Button className="w-full md:w-auto md:px-12 py-6 text-lg shadow-xl shadow-olive-light/20" data-id="element-50">
            YES! I WANT THE PROTOCOL
          </Button>
          <p className="mt-6 text-sm text-warm-dark/50 uppercase tracking-widest font-bold" data-id="element-51">
            Instant Digital Download
          </p>
        </div>
      </div>
    </section>;
}